import * as TableAreaHelper from "helpers/TableAreaHelper";

export const handleRequest = async (path, method) => {
  switch (path) {
    case "/tables":
      return await handleTables(method);
    default:
      return { message: "API not found", status: 404 };
  }
};

function handleTables(method) {
  if (method === "GET") {
    return getTables();
  }
  return { message: "Method not allowed", status: 405 };
}

async function getTables() {
  const data = await TableAreaHelper.getTablesFromDB();
  return {
    data,
    message: "Table list",
    status: 200,
  };
}
